"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityEditModalButton = EntityEditModalButton;
exports.EntityAddNewModalButton = EntityAddNewModalButton;
const react_1 = __importDefault(require("react"));
const GeneralModalButtons_1 = require("../../View/Modals/GeneralModalButtons");
const EntitiesController_1 = require("../EntitiesController");
const EntityModalBody_1 = require("./EntityModalBody");
const EntityValidationSchema_1 = require("./EntityValidationSchema");
/**
 * GUS-4b — okno podmiotu.
 *
 * `shouldRetrieveDataBeforeEdit` i `buttonProps` idą dalej, bo zakładka „Podmioty w GUS"
 * w panelu administracyjnym otwiera to samo okno z pozycji listy, mając tylko numer
 * i nazwę podmiotu — resztę (w tym migawkę z rejestru) musi dociągnąć modal. Z listy
 * podmiotów przychodzi komplet danych i nic się nie dociąga.
 *
 * PLAKIETKA GUS SIEDZI W CIELE OKNA, NIE W JEGO NAGŁÓWKU (`headerBadge`). Nagłówek dostaje
 * `initialData` przekazane z listy, a przy wejściu z panelu administracyjnego jest to sama
 * zajawka (numer, nazwa, NIP) — plakietka meldowałaby wtedy „nie sprawdzano" przy podmiocie,
 * który różni się od rejestru. Ciało okna dostaje rekord dociągnięty z serwera, więc mówi prawdę.
 */
function EntityEditModalButton({ modalProps: { onEdit, initialData, shouldRetrieveDataBeforeEdit }, buttonProps, }) {
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralEditModalButton, { modalProps: {
            onEdit: onEdit,
            ModalBodyComponent: EntityModalBody_1.EntityModalBody,
            modalTitle: "Edycja danych podmiotu",
            repository: EntitiesController_1.entitiesRepository,
            initialData: initialData,
            makeValidationSchema: EntityValidationSchema_1.makeEntityValidationSchema,
            shouldRetrieveDataBeforeEdit: shouldRetrieveDataBeforeEdit,
        }, buttonProps: {
            buttonVariant: "outline-success",
            ...buttonProps,
        } }));
}
function EntityAddNewModalButton({ modalProps: { onAddNew } }) {
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralAddNewModalButton, { modalProps: {
            onAddNew: onAddNew,
            ModalBodyComponent: EntityModalBody_1.EntityModalBody,
            modalTitle: "Dodaj podmiot",
            repository: EntitiesController_1.entitiesRepository,
            makeValidationSchema: EntityValidationSchema_1.makeEntityValidationSchema,
        }, buttonProps: {
            buttonCaption: "Dodaj podmiot",
            buttonVariant: "outline-success",
        } }));
}
